import axios from "../../../common/utils/axios";
import {
    AUTH_REQUEST,
    AUTH_SUCCESS,
    AUTH_LOGOUT,
    TOGGLE_AUTH_POPUP,
    REPLACE_AUTH_ACTIVE_COMPONENT,
    REGISTER_REQUEST,
    GOOGLE_AUTH_REQUEST,
    AUTH_RESET_PASSWORD_REQUEST,
    CHANGE_PASSWORD_REQUEST,
    UPDATE_AUTH_CUSTOMER_INFO,
    LOGOUT,
    REFRESH_TOKEN,
    SEND_VERIFICATION_CODE,
    CHECK_VERIFICATION_CODE,
    EDIT_MATCH_PERCENTAGE
} from "./actions";

import Signin from './../components/Signin'
import VerifyPhoneNumber from './../components/VerifyPhoneNumber'
import { ADD_TO_WATCHLIST, REMOVE_FROM_WATCHLIST } from "../../sell/store/actions";
import { ADD_KEYWORDS, SHOW_TOAST_MESSAGE } from "../../../common/store/actions";
import GeneralHelper from "../../../common/helpers/GeneralHelper";
import CustomerService from "../../../common/services/customer/CustomerService";

export default {
    state: {
        token: localStorage.getItem('token') || '',
        refresh_token: localStorage.getItem('refresh_token') || '',
        customer: JSON.parse(localStorage.getItem('customer')) || null,
        authPopupOpened: false,
        authActiveComponent: Signin,
        verifyMessage: '',
        authProperties:{},
        isloginWithGoogle:false,
    },
    getters: {
        // matchSelection: state => state.customer? state.customer.matchSelection: 70,
        token: state => state.token,
        isloginWithGoogle: state => state.isloginWithGoogle,
        refresh_token: state=>state.refresh_token,
        isAuthenticated: state => !!state.token,
        isAuthPopupOpened: state => state.authPopupOpened,
        authActiveComponent: state => state.authActiveComponent,
        authProperties: state => state.authProperties,
        customer: state => state.customer,
        verifyMessage: state => state.verifyMessage,
    },
    mutations: {
        setVerifyMessage: (state, verifyMessage) =>{
            state.verifyMessage = verifyMessage
        },

        setIsloginWithGoogle: (state, isloginWithGoogle) =>{
            state.isloginWithGoogle = isloginWithGoogle
        },

        setAuthProperties: (state, data) =>{
            state.authProperties = data
        },

        [AUTH_SUCCESS]: (state, { token, refresh_token, customer }) => {
            state.token = token;
            state.customer = customer;
            state.refresh_token = refresh_token;
            state.authPopupOpened = false;
        },
        [AUTH_LOGOUT]: state => {
            state.token = "";
            state.refresh_token = "";
            state.customer = null;
        },
        [TOGGLE_AUTH_POPUP]: (state, authPopupStatus) => {
            state.authPopupOpened = authPopupStatus;

        },
        [REPLACE_AUTH_ACTIVE_COMPONENT]: (state, component) => {
            state.authActiveComponent = component;
        },
        [ADD_TO_WATCHLIST]: (state, kit_id) => {

            if (!state.customer.watchlist)
                state.customer.watchlist = [];
            state.customer.watchlist.push({ id: kit_id });
            localStorage.setItem('customer', JSON.stringify(state.customer))
        },
        [REMOVE_FROM_WATCHLIST]: (state, kit_id) => {

            state.customer.watchlist = state.customer.watchlist.filter((kit) => {
                return kit.id !== kit_id
            });
            localStorage.setItem('customer', JSON.stringify(state.customer))
        },
        [UPDATE_AUTH_CUSTOMER_INFO]: (state, data) => {
            state.customer = data
            localStorage.setItem('customer', JSON.stringify(state.customer))
        }
    },
    actions: {
        [EDIT_MATCH_PERCENTAGE]: async (context, data) => {
            const customerService = new CustomerService()
            customerService.editMatchPercentage(data).then(()=>{
                if (context.state.customer)
                {
                    context.state.customer.match_percentage = data.match_percentage
                }
            })
           
        },
        [REGISTER_REQUEST]: (context, registrationData) => {
            return new Promise((resolve, reject) => {
                axios({ url: "auth/register", data: registrationData, method: "POST" })
                    .then(resp => {
                        var verifyMessage = resp.data.message
                        context.commit('setVerifyMessage', verifyMessage)
                     
                        // var d = resp.data.data == undefined ? resp.data : resp.data.data

                        // const token = d.access_token
                        // const customer = d.customer
                        // const refresh_token = resp.data.data.refresh_token

                        // localStorage.setItem("token", token);
                        // localStorage.setItem("refresh_token", refresh_token);
                        // localStorage.setItem("customer", JSON.stringify(customer));
                        // localStorage.setItem("refreshTime", Date.now());

                        // context.commit(AUTH_SUCCESS, { token, refresh_token, customer });
                        // resolve(resp);
                    })
                    .catch(err => {
                        localStorage.removeItem("user-token");
                        if (err.response.status == 422) {
                            context.dispatch(SHOW_TOAST_MESSAGE, GeneralHelper.buildMessage(3, "Email Already Exists !"))
                        }
                    });
            });
        },
        [LOGOUT]: async (context) => {
            let keywords= {}
            keywords['preferences'] = []
            keywords.preferences.push({
                value: '',
                type: "logout"
            })
            await context.dispatch(ADD_KEYWORDS, keywords)
            localStorage.removeItem("token");
            localStorage.removeItem('refresh_token');
            localStorage.removeItem("customer");
            localStorage.removeItem("isAdmin")
            
           
        },
        [AUTH_REQUEST]: ({ commit }, credentials) => {
            return new Promise((resolve, reject) => {
                axios({ url: "auth/login", data: { email: credentials.email, password: credentials.password, rememberMe:credentials.rememberMe }, method: "POST" })
                    .then(resp => {
                        const token = resp.data.data.access_token
                        const refresh_token = resp.data.data.refresh_token
                        const customer = resp.data.data.customer
                        const isAdmin = resp.data.data.isAdmin

                        if (!customer.is_phone_verified)
                        {
                       
                            commit('setAuthProperties', {email: credentials.email, firebase_custom_token:customer.firebase_custom_token})
                            commit(REPLACE_AUTH_ACTIVE_COMPONENT,VerifyPhoneNumber)
                            resolve(0)
                        }

                        localStorage.setItem("token", token);
                        localStorage.setItem("refresh_token", refresh_token);
                        localStorage.setItem("refreshTime", Date.now());
                        localStorage.setItem("customer", JSON.stringify(customer));
                        localStorage.setItem('isAdmin', isAdmin)
                        localStorage.setItem("email", '')
                        localStorage.setItem("password", '')


                        commit(AUTH_SUCCESS, { token, refresh_token, customer });

                        resolve(resp);
                    })
                    .catch(err => {
                        localStorage.removeItem("token");
                        localStorage.removeItem('refresh_token');
                        localStorage.removeItem("customer");
                        localStorage.removeItem('isAdmin')
                        reject(err);
                    });
            });
        },

        [SEND_VERIFICATION_CODE]: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                axios({ url: "auth/createPhoneVerificationCode", data: data, method: "POST" })
                    .then(resp => {
                        resolve(resp);
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        [CHECK_VERIFICATION_CODE]: (context, data) => {
            return new Promise((resolve, reject) => {
                axios({ url: "auth/verifyPhoneNumber", data: data, method: "POST" })
                    .then(resp => {
                        context.dispatch(SHOW_TOAST_MESSAGE, GeneralHelper.buildMessage(1, "Phone Verification Successful!"))
                        context.commit(REPLACE_AUTH_ACTIVE_COMPONENT,Signin)
                        resolve(resp);
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        [GOOGLE_AUTH_REQUEST]: (context, credentials) => {
            return new Promise((resolve, reject) => {
                axios({ url: "auth/googleLogin", data: credentials, method: "POST",authorization: false })
                    .then(resp => {
                        const token = resp.data.data.access_token
                        const refresh_token = resp.data.data.refresh_token
                        const customer = resp.data.data.customer
                        const isAdmin = resp.data.data.isAdmin


                        if (!customer.is_phone_verified)
                        {
                           
                            context.commit('setAuthProperties', {email: customer.email, firebase_custom_token:customer.firebase_custom_token})
                            context.commit(REPLACE_AUTH_ACTIVE_COMPONENT,VerifyPhoneNumber)
                            resolve(0)
                        }

                        localStorage.setItem("token", token);
                        localStorage.setItem("refresh_token", refresh_token);
                        localStorage.setItem("customer", JSON.stringify(customer));
                        localStorage.setItem('isAdmin', isAdmin)
                        localStorage.setItem("refreshTime", Date.now());
                        context.commit(AUTH_SUCCESS, { token, refresh_token, customer });
                        context.commit('setIsloginWithGoogle',true);
                        context.dispatch(SHOW_TOAST_MESSAGE, GeneralHelper.buildMessage(1, "Login Successful!"))
                        resolve(resp);
                    })
                    .catch(err => {
                        localStorage.removeItem("token");
                        localStorage.removeItem('refresh_token');
                        localStorage.removeItem("customer");
                        localStorage.removeItem("isAdmin")
                        reject(err);
                    });
            });
        },

        [AUTH_RESET_PASSWORD_REQUEST]: ({ commit }, { email, redirectUrl }) => {
            return new Promise((resolve, reject) => {
                axios({ url: "auth/resetPassword", data: { email, redirectUrl }, method: "POST", authorization: false })
                    .then(resp => {

                        resolve(resp);
                    })
                    .catch(err => {

                        reject(err);
                    });

            });
        },
        [CHANGE_PASSWORD_REQUEST]: ({ commit }, { password, email }) => {
            return new Promise((resolve, reject) => {
                axios({ url: "auth/changePassword", data: { password, email }, method: "POST", authorization: false })
                    .then(resp => {

                        resolve(resp);
                    })
                    .catch(err => {

                        reject(err);
                    });

            });
        },
        [AUTH_LOGOUT]: (context,{ commit }) => {
            return new Promise(resolve => {
                
                commit(AUTH_LOGOUT);
                localStorage.removeItem("token");
                localStorage.removeItem('refresh_token');
                localStorage.removeItem("customer");
                localStorage.removeItem('isAdmin')

                resolve();
                
            });
        },
        [TOGGLE_AUTH_POPUP]: (context, authPopupStatus) => {
            context.commit(TOGGLE_AUTH_POPUP, authPopupStatus)
            if (authPopupStatus == true) {
            }
        },
        [REPLACE_AUTH_ACTIVE_COMPONENT]: ({ commit }, component) => {
            commit(REPLACE_AUTH_ACTIVE_COMPONENT, component)
        },
        [REFRESH_TOKEN]: (context) => {
            return new Promise((resolve, reject) => {
                axios({ url: "auth/refresh_token", data: { refresh: context.getters.refresh_token}, method: "POST", authorization: false })
                    .then(resp => {
                        const token = resp.data.data.access_token
                        const refresh_token = resp.data.data.refresh_token
                        const customer = resp.data.data.customer
                        localStorage.setItem("token", token);
                        localStorage.setItem("refresh_token", refresh_token);
                        localStorage.setItem("customer", JSON.stringify(customer));
                        localStorage.setItem("refreshTime",Date.now())
                        context.commit(AUTH_SUCCESS, { token, refresh_token,customer });

                        resolve(resp);
                    })
                    .catch(err => {
                        if (err.message!="Network Error"||err.status!=408){
                            localStorage.removeItem("token");
                            localStorage.removeItem('refresh_token');
                            localStorage.removeItem("customer");
                            localStorage.removeItem('isAdmin')
                            context.commit(AUTH_LOGOUT);
                        }
                        reject(err);
                    });
            });
        },
    },
    modules: {},

};